import React from 'react';
import './ThemeToggle.css';

interface ThemeToggleProps {
  currentTheme: 'premium' | 'energetic';
  onToggle: () => void;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ currentTheme, onToggle }) => {
  return (
    <div className="v1-theme-toggle-wrapper">
      <button
        className="v1-theme-toggle"
        onClick={onToggle}
        aria-label="Toggle theme"
        title={`Switch to ${currentTheme === 'premium' ? 'Energetic' : 'Premium'} theme`}
      >
        <div className={`v1-toggle-track ${currentTheme}`}>
          <div className="v1-toggle-thumb">
            <span className="v1-toggle-icon">
              {currentTheme === 'premium' ? '✨' : '⚡'}
            </span>
          </div>
        </div>
        <div className="v1-toggle-labels">
          <span className={`v1-toggle-label ${currentTheme === 'premium' ? 'active' : ''}`}>
            Premium
          </span>
          <span className={`v1-toggle-label ${currentTheme === 'energetic' ? 'active' : ''}`}>
            Energetic
          </span>
        </div>
      </button>
    </div>
  );
};

export default ThemeToggle;
